module.exports = __webpack_public_path__ + "static/media/LitigioImgEng.5ba45a6e.png";